import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LabelModule } from '@shared/modules/form/modules/label/label.module';
import { CheckboxSimpleComponent } from './components/checkbox-simple/checkbox-simple.component';
import { CheckboxSwitchComponent } from './components/checkbox-switch/checkbox-switch.component';


@NgModule({
  declarations: [CheckboxSimpleComponent, CheckboxSwitchComponent],
  exports: [
    CheckboxSimpleComponent,
    CheckboxSwitchComponent
  ],
  imports: [
    CommonModule,
    LabelModule,
  ]
})
export class CheckboxModule { }
